import { Component, OnInit, ViewChild, AfterViewInit, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from 'app/models/route.model';
import { MatDialog } from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { Passenger } from 'app/models/passenger.model';
// import { Location } from 'app/models/location.model';
import { LocationsComponent } from 'app/dashboard/locations/locations.component';
import { DomainsService } from 'app/services/domains/domains.service';
import { LocationService } from 'app/services/locations/location.service';
import { RoutesComponent } from '../routes/routes.component';
import { RouteService } from 'app/services/routes/route.service';
import { Location } from '@angular/common';
import { Travel } from 'app/models/travel.model';
import { TravelService } from 'app/services/travel/travel.service';
import { MatSort } from '@angular/material/sort';
import { AlertsService } from 'app/services/alerts/alerts.service';
declare const swal: any;

@Component({
  selector: 'app-customer-domain',
  templateUrl: './customer-domain.component.html',
  styleUrls: ['./customer-domain.component.css']
})
export class CustomerDomainComponent implements OnInit {

  header: {
    title: string;
    contact: string;
    phone: string;
    email: string;
    accessCode: string;
  }
  resume: {
    routesCount: number,
    stopsCount: number
  };
  domainId: number;
  travels: Travel[];
  routes: Route[] = [];

  travelsDataSource: MatTableDataSource<any>;


  travelsDisplayedColumns: string[] = ['id', 'name', 'date', 'initTime', 'status'];
  locationsDisplayedColumns: string[] = ["name", "address", "action"];
  routesDataSource: MatTableDataSource<any>;
  locationsDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) travelsPaginator: MatPaginator;
  @ViewChild(MatSort) travelSort: MatSort;
  // @ViewChild(MatPaginator) locationPaginator: MatPaginator;
  // @ViewChild(MatPaginator) passengersPaginator: MatPaginator;
  // @ViewChildren(MatPaginator) paginator: MatPaginator;

  constructor(private activatedRouter: ActivatedRoute,
    private dialog: MatDialog,
    private domainService: DomainsService,
    private locationService: LocationService,
    private routeService: RouteService,
    private router: Router,
    private navigate: Location,
    private travelService: TravelService,
    private alertService: AlertsService) { }

   ngOnInit() {
    // let loading = this.alertService.showLoading('Cargando');
    // console.log(loading)
    
    // this.alertService.stopLoading(loading);
    this.domainId = this.activatedRouter.snapshot.params.id;
    this.domainService.getDomainById(this.domainId).subscribe((result) => {
      console.log('Cargando datos del dominio...', result);
      this.header = {
        title: result.customer.customerName,
        contact: result.customer.name,
        phone: result.customer.phone,
        email: '',
        accessCode: result.accessCode
      }
      console.log('Header => ', this.header);
    });
    this.domainService.getResume(this.domainId).subscribe((result) => {
      this.resume = {
        routesCount: result.routesCount,
        stopsCount: result.stopsCount
      }
    });
   }

   async ngAfterViewInit(){
    // await this.refreshPage();
    this.travels = await this.travelService.getTravels(this.domainId);
    this.travelsDataSource = new MatTableDataSource<any>(this.travels);
    this.travelsDataSource.paginator = this.travelsPaginator;
    this.travelsDataSource.sort = this.travelSort;
   }

  async refreshPage(){
    // this.location = new Location();
    
    
    // this.travelService.getTravels(this.domainId).subscribe((result) => {
    //   this.travels = result;
    //   console.log(this.travels);
    
    // });
    
    // this.locationService.getLocations(this.domainId).subscribe((result) => {
    //   console.log('Cargando ubicaciones...')
    //   this.locations = result;
    //   this.locationsDataSource = new MatTableDataSource<any>(this.locations);
    //   this.locationsDataSource.paginator = this.paginator;
    // });
    // this.routeService.getRoutes(this.domainId).subscribe((result) => {
    //   console.log('cargando rutas...');
    //   this.routes = result;
    //   this.routesDataSource = new MatTableDataSource<any>(this.routes);
      // this.routesDataSource.paginator = this.paginator;
    // })
  }

  navigateBack(){
    this.navigate.back();
  }

}
